import { jsx as r } from "react/jsx-runtime";
import e from "../base-button.mjs";
const a = (o) => /* @__PURE__ */ r(
  e,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-danger",
    hoverBackgroundColor: "hover:bg-danger",
    ...o
  }
);
export {
  a as DangerButton
};
